import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import SvgIcon from "@mui/material/SvgIcon";
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';

import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';





export default function BaseCarCard(props) {
  	let navigate = useNavigate(); 

	const { t, i18n } = useTranslation("",{lng: props.language});

	const callModel = (url) => {
		navigate(url);
	};
	
  	return (
			<Card sx={{ maxWidth: 345, minHeight:"350px" }} className="centerCarCard">
      			<CardHeader avatar={
					          <img style={{height: "30px", bgcolor: "#fff" }} aria-label="recipe" src={"/assets/logos/" + props.model.producerLogo} />					           
					          
					        }
        					title={props.model.baseModel}
							subheader={props.model.slogan}
      			/>
      			<CardContent sx={{ minHeight:"200px" }}>
			        <Typography variant="body2" color="text.secondary">
						{t("UVP")}<br/>{t("ab")} {Number(props.model.price).toLocaleString("de-DE", {minimumFractionDigits: 2}) + " €"}
			        </Typography>
			        <Typography variant="body2" color="text.secondary" sx={{ paddingTop:"10px", fontWeight: 400 }}>
						{props.model.baseModelDescriptionShort}
			        </Typography>
			        			
			        
				</CardContent>

				<CardActions >
        			{props.model.configurable == "true" ? (
	        			<Button aria-label="share"
	        					variant="contained"
	        					sx={{marginLeft: "5px"}}
	        					onClick={e => props.handleShowExpansion("false", props.model.url)}
	        					endIcon={<SettingsSuggestIcon />}>
	          				{t("auswählen")}
	        			</Button>
						) : 
						(<></>)
					}
				</CardActions>

    		</Card>
  );
}